import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';
import type { UpdateExerciseInput } from '../types';

import { exercisesKeys } from './useExercises';

export function useUpdateExercise(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateExerciseInput) => exercisesService.update(id, input),
    onSuccess: (exercise) => {
      void qc.invalidateQueries({ queryKey: exercisesKeys.lists() });
      qc.setQueryData(exercisesKeys.detail(id), exercise);
    },
  });
}
